import { disableResizeTransform, megaMenu, megaMenuOnHover, menuToggle } from "./modules/header";
import equalList from "./modules/equal-lists";
import eventsBorders from "./modules/events-borders";
import customVideoControls from "./modules/custom-video-controls";
import useCasesPopup from "./modules/use-cases-popup";
import useSliderCasesPopup from "./modules/use-case-slider-popup";
import { register } from "./modules/register";
import { myAccount, passwordValidation, profileValidation, registerValidation } from "./modules/my-account";

//blocks
import teamMembersCarousel from "./blocks/team-members-carousel";
import CalendarCarousel from "./blocks/calendar-slider";
import CounterCarousel from "./blocks/counter-slider";

document.addEventListener("DOMContentLoaded", () => {
  disableResizeTransform();
  equalList();
  eventsBorders();
  customVideoControls();
  teamMembersCarousel();
  CalendarCarousel();
  CounterCarousel();
  useCasesPopup();
  megaMenu();
  menuToggle();
  register();
  myAccount();
  registerValidation();
  profileValidation();
  passwordValidation();
  megaMenuOnHover();
  useSliderCasesPopup();
});

window.addEventListener("resize", () => {
  equalList();
});
